import type { ResolveWidgetRoute, WidgetRouteIntent } from './widgetRouteIntent'

function resolveAddBasePath(
  base: string,
  token0: string | undefined,
  token1: string | undefined,
): string {
  if (token0 == null && token1 == null) return base
  if (token0 != null && token1 == null) return `${base}/${token0}`
  if (token0 != null && token1 != null) return `${base}/${token0}/${token1}`
  /* solo segundo segmento (caso existente en add liquidity) */
  return `${base}/${token1 as string}`
}

function makeResolver(opts: {
  addBase: string
  removeBase: string
  importPath: string
  swapPath: string
}): ResolveWidgetRoute {
  const { addBase, removeBase, importPath, swapPath } = opts
  return (intent: WidgetRouteIntent): string => {
    switch (intent.type) {
      case 'swap':
        return swapPath
      case 'import':
        return importPath
      case 'remove':
        return `${removeBase}/${intent.token0}/${intent.token1}`
      case 'add':
        return resolveAddBasePath(addBase, intent.token0, intent.token1)
    }
  }
}

/** Rutas productivas: `/add`, `/remove`, `/import`, `/swap`. */
export function createMainAppResolveWidgetRoute(): ResolveWidgetRoute {
  return makeResolver({
    addBase: '/add',
    removeBase: '/remove',
    importPath: '/import',
    swapPath: '/swap',
  })
}

/**
 * Rutas del cajón embed (hash): liquidez bajo `/embed/liquidity/*` y swap en `/embed/swap`.
 * Usar en todas las páginas `src/pages/embed/*` para un resolver completo y homogéneo.
 */
export function createEmbedSandboxResolveWidgetRoute(): ResolveWidgetRoute {
  return makeResolver({
    addBase: '/embed/liquidity/add',
    removeBase: '/embed/liquidity/remove',
    importPath: '/embed/liquidity/import',
    swapPath: '/embed/swap',
  })
}

/** Instancia reutilizable para páginas productivas (evita recrear la función en cada render). */
export const mainAppResolveWidgetRoute = createMainAppResolveWidgetRoute()

/** Instancia reutilizable para páginas embed. */
export const embedSandboxResolveWidgetRoute = createEmbedSandboxResolveWidgetRoute()
